/**
 * DD Settings Tour
 *
 * Walkthrough for the Due Diligence configuration page.
 * Every step anchors to a real UI element via data-tour attributes.
 */

import { TourDefinition } from '../config/tourSteps';

export const ddSettingsTour: TourDefinition = {
  id: 'ddSettingsTour',
  steps: [
    {
      element: '[data-tour="dd-category-list"]',
      popover: {
        title: 'Categorieën',
        description:
          'Hier staan alle DD-categorieën. Elke categorie bevat vragen die per gebouw beantwoord worden, zoals "Juridisch", "Technisch" of "Milieu".',
        side: 'bottom',
        align: 'start',
      },
    },
    {
      element: '[data-tour="dd-add-category"]',
      popover: {
        title: 'Nieuwe Categorie',
        description:
          'Maak een nieuwe categorie aan met eigen vragen en antwoordopties.',
        side: 'bottom',
        align: 'start',
      },
    },
    {
      element: '[data-tour="dd-import-export"]',
      popover: {
        title: 'Importeren & Exporteren',
        description:
          'Exporteer uw DD-configuratie als JSON-bestand of importeer een configuratie vanuit een ander gebouw.',
        side: 'bottom',
        align: 'end',
      },
    },
  ],
  // After this tour, user navigates into a category editor
  nextPageUrl: undefined,
  nextTourId: 'ddConditionsTour',
};
